module.exports = __webpack_public_path__ + "static/media/Google_Chat_icon_(2020).88fc953e.svg";